function getBaseConfig() {
  return {
    datadog: {
      applicationId: process.env.NEXT_PUBLIC_DATA_DOG_APPLICATION_ID,
      clientToken: process.env.NEXT_PUBLIC_DATA_DOG_CLIENT_TOKEN,
      service: process.env.NEXT_PUBLIC_DATA_DOG_SERVICE,
      env: process.env.NEXT_PUBLIC_DATA_DOG_ENV,
      sampleRate: process.env.NEXT_PUBLIC_DATA_DOG_SAMPLE_RATE,
    },
  };
}

export { getBaseConfig };
